import styled from 'styled-components';
import { backgroundImage, hari } from '../../../contants';
import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';

const HariTile = () => {
  return (
    <Wrapper>
      <ProjectBackgroundImage alt='error' src={backgroundImage.project3} />
      <ContentWrapper>
        <Header>Pixels with Purpose</Header>
        <Content>
          {hari.projects.map((project, index) => (
            <Box key={index} as={motion.div} whileHover={{ scale: 1.1 }}>
              <NavLink to={`/harisumiran/${project.name}`}>
                {project.name === 'Sambandh' ? (
                  <Logo
                    style={{ backgroundColor: '#FF5A52' }}
                    src={project.logo}
                  />
                ) : (
                  <Logo src={project.logo} />
                )}
              </NavLink>
            </Box>
          ))}
        </Content>
      </ContentWrapper>
    </Wrapper>
  );
};

const Logo = styled.img`
  height: 100%;
  width: 100%;
  padding: 6px;
`;

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  border-radius: 30px;
`;
const ContentWrapper = styled.div`
  position: absolute;
  padding: 30px 36px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  @media (max-width: 500px) {
    padding: 12px 2px;
  }
`;
const Header = styled.div`
  margin-bottom: 8px;
  line-height: 32px;
  font-size: 24px;
  font-weight: 800;
  color: ${({ theme }) => theme.background};
  filter: drop-shadow(0.1rem 0.1rem 0.2rem hsla(0, 24%, 30%, 0.3));

  @media (max-width: 500px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 40px 0px;
  gap: 16px;
  @media (max-width: 500px) {
    gap: 8px;
    height: fit-content;
    padding: 8px 18px;
  }
`;
const BackgroundImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const ProjectBackgroundImage = styled(BackgroundImage)`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 30px;
`;

const Box = styled.div`
  background-color: white;
  flex: 1 1 calc(50% - 8px);
  border-radius: 24px;
  overflow: hidden;
  @media (max-width: 500px) {
    border-radius: 18px;
  }
`;

export default HariTile;
